import { useBreakpointValue } from "@chakra-ui/react"

export type IndicatorConfig = {
  indicator: string
  indicatorXs: string
  indicatorMd: string
  indicatorColor: string
  indicatorColorXs: string
  indicatorColorMd: string
  indicatorFocusColor: string
  indicatorFocusColorXs: string
  indicatorFocusColorMd: string
}

export const useCarouselStyleIndicator = (
  indicatorConfig: Record<string, IndicatorConfig>
) => {
  const { lg, md, xs } = indicatorConfig

  const indicatorType =
    useBreakpointValue({
      base: xs.indicatorXs,
      md: md.indicatorMd,
      lg: lg.indicator,
    }) ?? "thumbnail"

  const indicatorColor =
    useBreakpointValue({
      base: xs.indicatorColorXs,
      md: md.indicatorColorMd,
      lg: lg.indicatorColor,
    }) ?? "#ffffff"

  const indicatorFocusColor =
    useBreakpointValue({
      base: xs.indicatorFocusColorXs,
      md: md.indicatorFocusColorMd,
      lg: lg.indicatorFocusColor,
    }) ?? "#6c6c6c"

  return {
    indicatorType,
    indicatorColor,
    indicatorFocusColor,
  }
}
